import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SERVICES, IMAGES } from "../data/content";
import { Motif } from "../components/Motifs";
import { Reveal } from "../components/Primitives";
import { ConsultationForm } from "../components/Forms";

export default function Services() {
  return (
    <div data-testid="services-page">
      {/* HERO */}
      <section className="pt-36 pb-16 md:pt-44 md:pb-20 bg-[#120726] grain text-center">
        <div className="container-loft max-w-3xl mx-auto">
          <Reveal>
            <p className="overline mb-5">Ways We Walk Together</p>
            <h1 className="font-serif text-5xl md:text-7xl font-light leading-[1.03] text-[#EFE7FA]">
              <span className="text-gradient">Grow</span> · <span className="text-[#0B7A5A]">Build</span> · <span className="text-[#5B2C83]">Thrive</span>
            </h1>
            <p className="mt-7 text-lg md:text-xl font-light leading-relaxed text-[#EFE7FA]/75">
              Three pathways of support — for healing, for building, and for transformation —
              each rooted in The 5L Method™.
            </p>
          </Reveal>
        </div>
      </section>

      {/* SERVICE CATEGORIES */}
      <section className="pb-8 bg-[#1a0d33]">
        <div className="container-loft space-y-24 py-16">
          {SERVICES.map((s, idx) => (
            <Reveal key={s.key}>
              <div className={`grid md:grid-cols-12 gap-12 items-center ${idx % 2 === 1 ? "md:[direction:rtl]" : ""}`}>
                <div className="md:col-span-5 [direction:ltr]">
                  <div className="relative grain rounded-[2rem] overflow-hidden">
                    <div className="glow-ice absolute inset-0" />
                    <img
                      src={s.key === "grow" ? IMAGES.lotus : s.key === "build" ? IMAGES.lighthouse : IMAGES.loftBright}
                      alt={s.name}
                      className="relative z-10 w-full h-80 object-cover"
                    />
                  </div>
                </div>
                <div className="md:col-span-6 md:col-start-7 [direction:ltr]">
                  <Motif name={s.motif} className="w-12 h-12 mb-5" stroke={s.color} strokeWidth={1.1} />
                  <h2 className="font-serif text-4xl md:text-5xl font-light" style={{ color: s.color }}>{s.name}</h2>
                  <p className="overline mt-2">{s.tagline}</p>
                  <p className="mt-5 text-lg font-light leading-relaxed text-[#EFE7FA]/75">{s.desc}</p>
                  <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                    {s.items.map((it) => (
                      <li key={it} className="flex items-center gap-3 text-[#EFE7FA]/80">
                        <span className="h-6 w-6 rounded-full grid place-items-center shrink-0" style={{ background: `${s.color}1a` }}>
                          <Check size={14} style={{ color: s.color }} />
                        </span>
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* BOOKING */}
      <section id="book" className="py-24 md:py-32 bg-[#120726]">
        <div className="container-loft grid lg:grid-cols-12 gap-14 items-start">
          <Reveal className="lg:col-span-5">
            <p className="overline mb-4">Online Scheduling</p>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-[#EFE7FA] leading-tight">
              Book a consultation
            </h2>
            <p className="mt-5 text-lg font-light leading-relaxed text-[#EFE7FA]/70">
              Share a few details and your preferred time. We'll reach out to confirm your session
              within the Loft — a calm, judgment-free space to begin.
            </p>
            <div className="mt-8 relative grain rounded-[2rem] overflow-hidden">
              <div className="glow-ice absolute inset-0" />
              <img src={IMAGES.lighthouse} alt="" className="relative z-10 w-full h-64 object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.12} className="lg:col-span-6 lg:col-start-7">
            <div className="card-soft p-8 md:p-10">
              <ConsultationForm />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
